import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/preferences/index.tsx";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { changeSetting } from 'soapbox/actions/settings';
import List, { ListItem } from 'soapbox/components/list';
import { Form } from 'soapbox/components/ui';
import { SelectDropdown } from 'soapbox/features/forms';
import SettingToggle from 'soapbox/features/notifications/components/setting_toggle';
import { useFeatures, useSettings } from 'soapbox/hooks';
import ThemeToggle from '../ui/components/theme-toggle';
const languages = {
  en: 'English',
  ar: 'العربية',
  ast: 'Asturianu',
  bg: 'Български',
  bn: 'বাংলা',
  ca: 'Català',
  co: 'Corsu',
  cs: 'Čeština',
  cy: 'Cymraeg',
  da: 'Dansk',
  de: 'Deutsch',
  el: 'Ελληνικά',
  'en-Shaw': '𐑖𐑱𐑝𐑾𐑯',
  eo: 'Esperanto',
  es: 'Español',
  eu: 'Euskara',
  fa: 'فارسی',
  fi: 'Suomi',
  fr: 'Français',
  ga: 'Gaeilge',
  gl: 'Galego',
  he: 'עברית',
  hi: 'हिन्दी',
  hr: 'Hrvatski',
  hu: 'Magyar',
  hy: 'Հայերեն',
  id: 'Bahasa Indonesia',
  io: 'Ido',
  is: 'íslenska',
  it: 'Italiano',
  ja: '日本語',
  ka: 'ქართული',
  kk: 'Қазақша',
  ko: '한국어',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  ml: 'മലയാളം',
  ms: 'Bahasa Melayu',
  nl: 'Nederlands',
  no: 'Norsk',
  oc: 'Occitan',
  pl: 'Polski',
  pt: 'Português',
  'pt-BR': 'Português do Brasil',
  ro: 'Română',
  ru: 'Русский',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  sq: 'Shqip',
  sr: 'Српски',
  'sr-Latn': 'Srpski (latinica)',
  sv: 'Svenska',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  th: 'ไทย',
  tr: 'Türkçe',
  uk: 'Українська',
  zh: '中文',
  'zh-CN': '简体中文',
  'zh-HK': '繁體中文（香港）',
  'zh-TW': '繁體中文（臺灣）'
};

// This is temporary, need to use full range of ISO languages like here.
// https://akkoma.dev/AkkomaGang/akkoma-fe/pulls/387
const postLanguages = languages;
const messages = defineMessages({
  heading: {
    "id": "column.preferences",
    "defaultMessage": "Preferences"
  },
  display_media_default: {
    "id": "preferences.fields.display_media.default",
    "defaultMessage": "Hide media marked as sensitive"
  },
  display_media_hide_all: {
    "id": "preferences.fields.display_media.hide_all",
    "defaultMessage": "Always hide media"
  },
  display_media_show_all: {
    "id": "preferences.fields.display_media.show_all",
    "defaultMessage": "Always show media"
  },
  privacy_public: {
    "id": "preferences.options.privacy_public",
    "defaultMessage": "Public"
  },
  privacy_local: {
    "id": "preferences.options.privacy_local",
    "defaultMessage": "Local-only"
  },
  privacy_unlisted: {
    "id": "preferences.options.privacy_unlisted",
    "defaultMessage": "Unlisted"
  },
  privacy_followers_only: {
    "id": "preferences.options.privacy_followers_only",
    "defaultMessage": "Followers-only"
  },
  content_type_plaintext: {
    "id": "preferences.options.content_type_plaintext",
    "defaultMessage": "Plain text"
  },
  content_type_markdown: {
    "id": "preferences.options.content_type_markdown",
    "defaultMessage": "Markdown"
  }
});
const Preferences = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const features = useFeatures();
  const settings = useSettings();
  const onSelectChange = (event, path) => {
    dispatch(changeSetting(path, event.target.value, {
      showAlert: true
    }));
  };
  const onToggleChange = (key, checked) => {
    dispatch(changeSetting(key, checked, {
      showAlert: true
    }));
  };
  const displayMediaOptions = React.useMemo(() => ({
    default: intl.formatMessage(messages.display_media_default),
    hide_all: intl.formatMessage(messages.display_media_hide_all),
    show_all: intl.formatMessage(messages.display_media_show_all)
  }), [intl]);
  const defaultPrivacyOptions = React.useMemo(() => _objectSpread(_objectSpread({
    public: intl.formatMessage(messages.privacy_public)
  }, features.localOnlyPrivacy ? {
    local: intl.formatMessage(messages.privacy_local)
  } : {}), {}, {
    unlisted: intl.formatMessage(messages.privacy_unlisted),
    private: intl.formatMessage(messages.privacy_followers_only)
  }), [features.localOnlyPrivacy, intl]);
  const defaultContentTypeOptions = React.useMemo(() => ({
    'text/plain': intl.formatMessage(messages.content_type_plaintext),
    'text/markdown': intl.formatMessage(messages.content_type_markdown)
  }), [intl]);
  return /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(List, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "home.column_settings.show_reblogs",
      defaultMessage: "Show reposts",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 132,
        columnNumber: 18
      }
    }),
    hint: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.hints.feed",
      defaultMessage: "In your home feed",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 133,
        columnNumber: 17
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['home', 'shows', 'reblog'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "home.column_settings.show_replies",
      defaultMessage: "Show replies",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 139,
        columnNumber: 18
      }
    }),
    hint: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.hints.feed",
      defaultMessage: "In your home feed",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140,
        columnNumber: 17
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['home', 'shows', 'reply'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(List, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.theme",
      defaultMessage: "Theme",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 147,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ThemeToggle, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.language_label",
      defaultMessage: "Language",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 151,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SelectDropdown, {
    items: languages,
    defaultValue: settings.get('locale'),
    onChange: event => onSelectChange(event, ['locale']),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.media_display_label",
      defaultMessage: "Media display",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SelectDropdown, {
    items: displayMediaOptions,
    defaultValue: settings.get('displayMedia'),
    onChange: event => onSelectChange(event, ['displayMedia']),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160,
      columnNumber: 11
    }
  })), features.privacyScopes && /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.privacy_label",
      defaultMessage: "Default post privacy",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 168,
        columnNumber: 28
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(SelectDropdown, {
    items: defaultPrivacyOptions,
    defaultValue: settings.get('defaultPrivacy'),
    onChange: event => onSelectChange(event, ['defaultPrivacy']),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 13
    }
  })), features.richText && /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.content_type_label",
      defaultMessage: "Default post format",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 178,
        columnNumber: 28
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 178,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(SelectDropdown, {
    items: defaultContentTypeOptions,
    defaultValue: settings.get('defaultContentType'),
    onChange: event => onSelectChange(event, ['defaultContentType']),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.post_language",
      defaultMessage: "Default post language",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 186,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 186,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SelectDropdown, {
    items: postLanguages,
    defaultValue: settings.get('defaultPostLanguage'),
    onChange: event => onSelectChange(event, ['defaultPostLanguage']),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 187,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(List, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 195,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.boost_modal_label",
      defaultMessage: "Show confirmation dialog before reposting",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 196,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['boostModal'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.delete_modal_label",
      defaultMessage: "Show confirmation dialog before deleting a post",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 200,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['deleteModal'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 201,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(List, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 205,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.auto_play_gif_label",
      defaultMessage: "Auto-play animated GIFs",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 206,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 206,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['autoPlayGif'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 11
    }
  })), features.spoilers && /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.expand_spoilers_label",
      defaultMessage: "Always expand posts marked with content warnings",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 210,
        columnNumber: 48
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 31
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['expandSpoilers'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 211,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.autoload_timelines_label",
      defaultMessage: "Automatically load new posts when scrolled to the top of the page",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 214,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 214,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['autoloadTimelines'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(ListItem, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "preferences.fields.autoload_more_label",
      defaultMessage: "Automatically load more items when scrolled to the bottom of the page",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 218,
        columnNumber: 26
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 218,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SettingToggle, {
    settings: settings,
    settingPath: ['autoloadMore'],
    onChange: onToggleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 219,
      columnNumber: 11
    }
  }))));
};
export { Preferences as default, languages, postLanguages };